export default __webpack_public_path__ + "static/media/Asset 6.4c280b90.png";